export default {
      id: "ic-fil-search-white-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic-fil-search-white-usage",
      toString: function () {
        return this.url;
      }
    }